import { getUserUuid } from './getUserUuid';
import getAccessTokenCookie from './cookies/getAccessTokenCookie';
import getIdTokenCookie from './cookies/getIdTokenCookie';
export var LoggedInState = /*#__PURE__*/function (LoggedInState) {
  LoggedInState["SOFT"] = "soft";
  LoggedInState["HARD"] = "hard";
  LoggedInState["NONE"] = "";
  return LoggedInState;
}({});
export var getAuthState = function getAuthState() {
  var accessToken = getAccessTokenCookie();
  var idToken = getIdTokenCookie();
  var userUuid = getUserUuid();
  if (accessToken && userUuid) {
    return {
      uuid: userUuid,
      state: LoggedInState.HARD
    };
  } else if (idToken && userUuid) {
    return {
      uuid: userUuid,
      state: LoggedInState.SOFT
    };
  }
  return {
    uuid: '',
    state: LoggedInState.NONE
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/getAuthState.js
// module id = 2871
// module chunks = 11